import { Select } from "@app/shared/modules/ui-components/q-select/q-select.component";

export const AdjacentResourcesOptions: Select = [
  { label: "Commission", value: "COMMISSION" },
  { label: "Showings", value: "SHOWINGS" },
];
